import { FC } from "react";

type IProps = {
  stroke?: string;
};

const IconCreatePermission: FC<IProps> = () => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.625 6.3125V7.1875C9.625 7.37891 9.46094 7.51562 9.29688 7.51562H6.89062V9.92188C6.89062 10.1133 6.72656 10.25 6.5625 10.25H5.6875C5.49609 10.25 5.35938 10.1133 5.35938 9.92188V7.51562H2.95312C2.76172 7.51562 2.625 7.37891 2.625 7.1875V6.3125C2.625 6.14844 2.76172 5.98438 2.95312 5.98438H5.35938V3.57812C5.35938 3.41406 5.49609 3.25 5.6875 3.25H6.5625C6.72656 3.25 6.89062 3.41406 6.89062 3.57812V5.98438H9.29688C9.46094 5.98438 9.625 6.14844 9.625 6.3125ZM12.25 1.9375V11.5625C12.25 12.3008 11.6484 12.875 10.9375 12.875H1.3125C0.574219 12.875 0 12.3008 0 11.5625V1.9375C0 1.22656 0.574219 0.625 1.3125 0.625H10.9375C11.6484 0.625 12.25 1.22656 12.25 1.9375ZM10.9375 11.3984V2.10156C10.9375 2.01953 10.8555 1.9375 10.7734 1.9375H1.47656C1.36719 1.9375 1.3125 2.01953 1.3125 2.10156V11.3984C1.3125 11.5078 1.36719 11.5625 1.47656 11.5625H10.7734C10.8555 11.5625 10.9375 11.5078 10.9375 11.3984Z"
        fill="black"
      />
    </svg>
  );
};

export default IconCreatePermission;
